const HumanSecurityAPI = () => (
  <script src="//client.px-cloud.net/PXIRnC16B3/main.min.js" async></script>
);

export default HumanSecurityAPI;
